import api from "./axios";

export const fetchUsers = async (page = 1, params = {}) => {
  const query = new URLSearchParams({ page, ...params }).toString();
  return api.get(`/users?${query}`);
};

export const updateUserStatus = async (id, is_active) => {
  return api.patch(`/users/${id}/status`, { is_active });
};
